module.exports = __webpack_public_path__ + "static/media/outlet_profile.31791411.svg";